<template>
  <component :is="userData === undefined ? 'div' : 'b-card'">
    <!-- Alert: No item found -->
    <b-alert variant="danger" :show="userData === undefined">
      <h4 class="alert-heading">Error fetching user data</h4>
      <div class="alert-body">
        No user found with this user id. Check
        <b-link class="alert-link" :to="{ name: 'admin-users-list' }">
          User List
        </b-link>
        for other users.
      </div>
    </b-alert>

    <b-tabs v-if="userData" pills>
      <!-- Tab: Account -->
      <b-tab active>
        <template #title>
          <i class="far fa-user mr-0 mr-sm-2"></i>
          <span class="d-none d-sm-inline">Account</span>
        </template>
        <user-edit-tab-account
          :rolesData="rolesOptions"
          :user-data="userData"
          class="mt-2 pt-5"
        />
      </b-tab>

      <!-- Tab: Information -->
      <b-tab>
        <template #title>
          <i class="fas fa-info mr-0 mr-sm-2"></i>
          <span class="d-none d-sm-inline">Information</span>
        </template>
        <user-edit-tab-information class="mt-2 pt-5" :user-data="userData" />
      </b-tab>

      <!-- Tab: Social -->
      <!-- <b-tab>
        <template #title>
          <feather-icon
            icon="Share2Icon"
            size="16"
            class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">Social</span>
        </template>
        <user-edit-tab-social class="mt-2 pt-75" />
      </b-tab> -->
    </b-tabs>
  </component>
</template>

<script>
import { BTab, BTabs, BCard, BAlert, BLink } from "bootstrap-vue";
import { ref } from "@vue/composition-api";
import router from "@/router";
import UserEditTabAccount from "./UserEditTabAccount.vue";
import UserEditTabInformation from "./UserEditTabInformation.vue";
import UserEditTabSocial from "./UserEditTabSocial.vue";

import axiosU from "@/core/services/api/admin/user";
import axiosR from "@/core/services/api/admin/roles";

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,

    UserEditTabAccount,
    UserEditTabInformation,
    UserEditTabSocial,
  },
  setup() {
    const rolesOptions = ref([]);
    const userData = ref(null);


    axiosR.rolesList().then(res => {
      const data = res?.data ?? res
      rolesOptions.value = (Array.isArray(data) ? data : []).map((item) => {
        const parsedId = Number(item?.id ?? item?.role_id)
        const id = Number.isFinite(parsedId) ? parsedId : item?.id ?? item?.role_id
        return { ...item, id, role_id: id }
      });
    });

    // Get user data
    axiosU.userDetail(router.currentRoute.params.id).then(res => {
      const registro = res?.registro ?? res?.data ?? res
      // Normalizamos a Number para que treeselect pueda hacer match
      // con el `id` de las opciones (que típicamente viene como number).
      const rolesUpdate = Array.isArray(registro.roles)
        ? registro.roles.map(item => {
            const parsedId = Number(item?.role_id ?? item?.id)
            return Number.isFinite(parsedId) ? parsedId : item?.role_id ?? item?.id
          })
        : []

      const facilitiesUpdate = Array.isArray(registro.facilities)
        ? registro.facilities.map(item => {
            const parsedId = Number(item?.facilities_id ?? item?.id)
            return Number.isFinite(parsedId) ? parsedId : item?.facilities_id ?? item?.id
          })
        : []
      registro.roles = rolesUpdate
      registro.facilities = facilitiesUpdate
      registro.pay_to_visit = registro.pay_to_visit ?? null
      userData.value = registro
    });

    return {
      userData,
      rolesOptions,
    };
  },
};
</script>


